import {
  faMagnifyingGlass,
  faFaceGrinBeam,
  faFaceDizzy,
} from '@fortawesome/free-solid-svg-icons';

export const orderSourceChoices = {
  widget: 'Widget',
  whatsapp: 'WhatsApp',
  backoffice: 'Backoffice',
  ai_order_taker: 'Julia',
  ai_analyzer: 'Felipe',
  api_integration: 'Demanda Agregada',
  ai_call_center: 'Llamados AI',
  other: 'Otro',
};

export const orderOperationModeChoices = {
  manual: 'Manual',
  automatic: 'Automático',
};

export const canceledOrderWithoutNoStockReasonsChoices = [
  'high_price',
  'no_response',
  'error',
  'is_duplicated',
  'no_reason',
  'no_client_response',
  'unmanaged',
  'referred',
  'buy_in_other_place',
  'branch_purchase',
  'no_client_info',
  'not_interesting',
] as const;

export const canceledOrderNoStockReasonsChoices = [
  'unavailable_model',
  'unavailable_brand',
  'unavailable_products',
  'invalid_vehicle_year',
  'no_stock',
  'long_delivery_time',
] as const;

export const canceledOrderReasonsChoices = [
  ...canceledOrderNoStockReasonsChoices,
  ...canceledOrderWithoutNoStockReasonsChoices,
] as const;

export const canceledOrderReasonsChoicesMessage = {
  unavailable_model: true,
  unavailable_brand: true,
  unavailable_products: true,
  invalid_vehicle_year: true,
  no_stock: true,
  long_delivery_time: null,
  no_reason: undefined,
  high_price: undefined,
  no_response: undefined,
  error: null,
  is_duplicated: null,
  not_interesting: undefined,
  no_client_response: undefined,
  unmanaged: undefined,
  referred: null,
  buy_in_other_place: null,
  branch_purchase: null,
  no_client_info: undefined,
};

export const orderSearchChoices = {
  'id:': 'id:',
  'name:': 'nombre pedido:',
  'products:': 'productos:',
  'client_name:': 'nombre cliente:',
  'client_phone:': 'teléfono cliente:',
  'car:': 'auto:',
  'car_plate:': 'patente:',
  'client_comment:': 'notas del cliente:',
  'internal_sale_number:': 'número de venta interna:',
};

export const orderStatusChoicesTag = {
  request: {
    label: 'Pedido Ingresado',
    color: 'gray',
  },
  identifying_car: {
    label: 'Identificando Vehículo',
    color: 'blue',
  },
  identifying_products: {
    label: 'Identificando Productos',
    color: 'blue',
  },
  searching_oems: {
    label: 'Buscando Códigos',
    color: 'blue',
  },
  searching_stock: {
    label: 'Buscando Stock',
    color: 'blue',
  },
  order_quoted: {
    label: 'Pedido Cotizado',
    color: 'blue',
  },
  quotation_sent: {
    label: 'Cotización Enviada',
    color: 'lime',
  },
  options_accepted: {
    label: 'Opciones Aceptadas',
    color: 'lime',
  },
  purchase_completed: {
    label: 'Compra Realizada',
    color: 'green',
  },
  pending_delivery: {
    label: 'Pendiente de entrega',
    color: 'green',
  },
  finished: {
    label: 'Venta finalizada',
    color: 'green',
  },
  canceled: {
    label: 'Cancelado',
    color: 'red',
  },
};

export const orderEstimatedCategoryChoicesTag = {
  gold: {
    label: 'Oro',
    color: 'gold',
  },
  silver: {
    label: 'Plata',
    color: 'cyan',
  },
  bronze: {
    label: 'Bronce',
    color: 'orange',
  },
  normal: {
    label: 'Normal',
    color: 'purple',
  },
  trash: {
    label: 'Basura',
    color: '#9CA174',
  },
};

export const orderSourceChoicesTag = {
  widget: {
    label: 'Widget',
    color: 'purple',
  },
  whatsapp: {
    label: 'Whatsapp',
    color: 'green',
  },
  backoffice: {
    label: 'Backoffice',
    color: 'blue',
  },
  ai_order_taker: {
    label: 'AI Agente',
    color: 'orange',
  },
  ai_analyzer: {
    label: 'AI Analizador',
    color: 'blue',
  },
  api_integration: {
    label: 'Demanda Agregada',
    color: 'cyan', // Or any other suitable color
  },
  ai_call_center: {
    label: 'Llamadas IA',
    color: 'magenta',
  },
  other: {
    label: 'Otro',
    color: 'grey',
  },
};

export const orderCarIdentificationStatusChoices = {
  requested_plate: 'Patente Solicitada',
  requested_vin: 'VIN Solicitado',
  requested_brand_model_year: 'Marca, Modelo y Año Solicitados',
  searching_plate_information: 'Buscando Información de Patente',
  car_unidentified: 'Vehículo No Identificado',
  finished: 'Venta finalizada',
};

export const orderProductIdentificationStatusChoices = {
  requested_products: 'Repuestos Solicitados',
  requested_confirmation: 'Confirmación Solicitada',
  verifying_products: 'Verificando Repuestos',
  some_products_unidentified: 'Algunos Repuestos No Identificados',
  products_unidentified: 'Repuestos No Identificados',
};

export const orderOemSearchStatusChoices = {
  searching_oems: 'Buscando códigoss',
  some_oems_unidentified: 'Algunos códigos No Identificados',
  oems_unidentified: 'Códigos No Identificados',
};

export const orderStockSearchStatusChoices = {
  searching_stock: 'Buscando Stock',
  some_products_not_found: 'Algunos Repuestos No Encontrados',
  products_not_found: 'Repuestos No Encontrados',
};

export const orderStatusChoicesForToQuote = [
  'identifying_car',
  'identifying_products',
  'searching_oems',
  'searching_stock',
  'order_quoted',
];

export const orderPaymentMethodChoices = [
  'webpay',
  'bank_transfer',
  'in_person',
  'partsflow',
  'other',
] as const;

export const orderImageContextChoices = [
  'transfer_receipt',
  ...orderPaymentMethodChoices,
] as const;

export const orderDeliveryMethodChoices = [
  'local_withdrawal',
  'shipped',
] as const;

export const orderCourierChoice = [
  'chilexpress',
  'starken',
  'internal',
  'other',
] as const;

export const orderStatusChoices = [
  'draft',
  'request',
  'identifying_car',
  'identifying_products',
  'searching_oems',
  'searching_stock',
  'order_quoted',
  'quotation_sent',
  'options_accepted',
  'purchase_completed',
  'pending_delivery',
  'finished',
  'canceled',
  'devolution_requested',
  'unmanaged',
] as const;

export const codeSearchStatusChoices = [
  'not_searched',
  'searching',
  'found',
  'not_found',
] as const;

export const codeSearchColors = {
  not_searched: '#F39C11',
  searching: '#27AE61',
  found: '#27AE61',
  not_found: '#C1392B',
};

export const codeSearchIcon = {
  not_searched: faMagnifyingGlass,
  searching: faMagnifyingGlass,
  found: faFaceGrinBeam,
  not_found: faFaceDizzy,
};

// Cómo llega el producto cotizado. `immediate` es lo de siempre; las otras dos llevan plazo.
export const orderFulfillmentChoices = [
  'immediate',
  'on_request',
  'import',
] as const;

export const orderDeferredFulfillmentChoices = [
  'on_request',
  'import',
] as const;

// Plazos frecuentes en días: el valor es el máximo, que es lo que se guarda y se promete.
export const orderLeadTimePresets = {
  on_request: [3, 7, 15],
  import: [30, 45, 60],
} as const;
